module.exports = __webpack_public_path__ + "static/media/level-up.da3ff31e.png";